import Heading from "@core/components/title/Heading";

export default function PlayncWaiting({ isWithdrawn = false }: { isWithdrawn?: boolean }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center text-center max-lg:pb-[30px]">
      <Heading level={1} className="text-lg font-normal">
        <span className="font-bold">PC방 사장님,</span> 안녕하세요! <br />
        {isWithdrawn ? (
          <>
            개인정보 및 사업장 전체 삭제
            <br /> 상태입니다.
          </>
        ) : (
          "회원가입 승인 대기중입니다."
        )}
      </Heading>
      <div className="mt-[40px] w-full max-w-[214px] bg-[#FFF9EB] py-[30px]">고객센터: 1566-0020</div>
    </div>
  );
}
